/* eslint-disable @next/next/no-img-element */
import React, { useEffect, useState } from 'react'
import { ProductList } from '../product/ProductList'
import { ButtonMain } from '~src/components/global/Button/ButtonMain/ButtonMain'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
import { useQuery } from 'react-query'
import { graphQLClient, graphQLClientGET } from '~src/api/graphql'
import { GET_PRODUCTS } from '~src/api/product'
import Link from 'next/link'
import TitleAni from './TitleAni'
export const ProductUs = () => {
  const { data: dataProducts, isLoading: isLoadingDataProducts } = useQuery({
    queryKey: ['getProductsUs'],
    queryFn: async () => {
      const data = (await graphQLClientGET.request(GET_PRODUCTS, {
        search: '',
        pageSize: 12,
        currentPage: 1,
      })) as {
        products: {
          items: TProduct[]
          page_info: {
            current_page: number
            page_size: number
            total_pages: number
          }
        }
      }
      return data?.products
    },
  })

  // useEffect(() => {
  //   gsap.registerPlugin(ScrollTrigger);

  //   const title = document.querySelector(".title-product-us");

  //   gsap.set(title, { opacity: 0, y: 100 });

  //   ScrollTrigger.create({
  //     trigger: title,
  //     start: "top 80%",
  //     end: "top 30%",
  //     onEnter: () => {
  //       gsap.to(title, {
  //         opacity: 1,
  //         y: 0,
  //         duration: 1,
  //         ease: "power2.out",
  //       });
  //     },
  //     onLeaveBack: () => {
  //       gsap.to(title, {
  //         opacity: 0,
  //         y: 100,
  //         duration: 1,
  //         ease: "power2.out",
  //       });
  //     },
  //   });
  // }, []);

  return (
    <div className="product-us relative">
      <div className="ani-top h-[8rem] absolute bottom-[100%] left-0 w-full overflow-hidden z-[-1] max-md:h-[4rem]">
        <svg
          className="ani-waves"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          viewBox="0 24 150 28"
          preserveAspectRatio="none"
          shapeRendering="auto"
        >
          <defs>
            <path
              id="gentle-wave"
              d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"
            ></path>
          </defs>
          <g className="parallax">
            <use xlinkHref="#gentle-wave" x="48" y="5" fill="#239F40"></use>
          </g>
        </svg>
      </div>
      <div className="absolute top-[11%] left-[2%] z-2 ani-arrow-svg max-lg:hidden">
        <svg
          width="84"
          height="147"
          viewBox="0 0 84 147"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M83.4816 22.2969L83.4816 54.9141L41.6435 32.6172L1.4055e-05 54.9141L1.26292e-05 22.2969L41.6435 -2.10594e-05L83.4816 22.2969Z"
            fill="#C82127"
          />
          <path
            d="M83.4816 63.7047L83.4816 74.4072L41.6435 52.1103L1.4055e-05 74.4072L1.35871e-05 63.7047L41.6435 41.5352L83.4816 63.7047Z"
            fill="#C82127"
          />
          <path
            d="M83.4816 81.8532L83.4816 92.5557L41.6435 70.2588L1.4055e-05 92.5557L1.35871e-05 81.8532L41.6435 59.6837L83.4816 81.8532Z"
            fill="#C82127"
          />
          <path
            d="M83.4816 100.001L83.4816 110.704L41.6435 88.4067L1.4055e-05 110.704L1.35871e-05 100.001L41.6435 77.8316L83.4816 100.001Z"
            fill="#C82127"
          />
          <path
            d="M83.4816 118.149L83.4816 128.852L41.6435 106.555L1.4055e-05 128.852L1.35871e-05 118.149L41.6435 95.9796L83.4816 118.149Z"
            fill="#C82127"
          />
          <path
            d="M83.4816 136.297L83.4816 147L41.6435 124.703L1.4055e-05 147L1.35871e-05 136.297L41.6435 114.128L83.4816 136.297Z"
            fill="#C82127"
          />
        </svg>
      </div>
      <div className="absolute top-[2%] left-[4%] z-1 arrow-white ani-arrow-svg reverse max-lg:hidden">
        <svg
          width="119"
          height="208"
          viewBox="0 0 119 208"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g opacity="0.1">
            <path
              d="M118.125 31.5494L118.125 77.7017L58.9255 46.1523L0.00143433 77.7017L0.00143231 31.5495L58.9255 8.6511e-05L118.125 31.5494Z"
              fill="white"
            />
            <path
              d="M118.125 90.14L118.125 105.284L58.9255 73.7343L0.00143433 105.284L0.00143366 90.14L58.9255 58.7709L118.125 90.14Z"
              fill="white"
            />
            <path
              d="M118.125 115.819L118.125 130.963L58.9255 99.4135L0.00143433 130.963L0.00143366 115.819L58.9255 84.4501L118.125 115.819Z"
              fill="white"
            />
            <path
              d="M118.125 141.498L118.125 156.642L58.9255 125.093L0.00143433 156.642L0.00143366 141.498L58.9255 110.129L118.125 141.498Z"
              fill="white"
            />
            <path
              d="M118.125 167.177L118.125 182.321L58.9255 150.771L0.00143433 182.321L0.00143366 167.177L58.9255 135.808L118.125 167.177Z"
              fill="white"
            />
            <path
              d="M118.125 192.856L118.125 208L58.9255 176.451L0.00143433 208L0.00143366 192.856L58.9255 161.487L118.125 192.856Z"
              fill="white"
            />
          </g>
        </svg>
      </div>
      <div className="absolute top-0 right-0 w-[30%] z-1 img-position max-lg:hidden">
        <img src="/image/img-product-us.png" alt="" />
      </div>
      <div className="containers">
        <div className="content-product-us">
          <div className="title title-product-us pb-[6rem] relative max-md:pb-[0rem]">
            <span className="absolute top-[0] w-[100vw] left-[50%] translate-x-[-50%] bg-[#239F40] z-[-2] h-[150%]"></span>
            <div className="icon-brand mx-auto">
              <img src="/image/ic-brand-white.svg" alt="" />
            </div>
            <TitleAni title="SẢN PHẨM CỦA CHÚNG TÔI" className="text-white"></TitleAni>
          </div>
          <div className="wrapper-product">
            <div className="list-product">
              <ProductList
                data={dataProducts?.items || []}
                loading={isLoadingDataProducts}
                hideIcon={true}
              />
            </div>
          </div>

          {(dataProducts?.items?.length as number) > 0 && (
            <div className="button-all">
              <Link
                href={{
                  pathname: '/product',
                }}
              >
                <a>
                  <ButtonMain background="green" type="button">
                    <div className="text-all">
                      <span>Xem tất cả</span>
                    </div>
                  </ButtonMain>
                </a>
              </Link>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
